export default "__VITE_ASSET__CJx1Dlwr__"